let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6kUQ")).then(() => parcelRequire('27N5H'));